export abstract class Repository {}
